export abstract class Repository {}
